export const LEFT = "left";
export const RIGHT = "right";
export const SCROLL_DISTANCE = 300;
export const MEDIUM_VIEWPORT_BREAKPOINT = "768px";
export const MEDIUM_VIEWPORT_MEDIA_QUERY = "(min-width: 768px)";
export const VISIBILITY_THRESHOLD = 0.05;
export const INTERSECTION_THRESHOLDS = [0, VISIBILITY_THRESHOLD];
export const FOCUSABLE_SELECTOR =
  'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';
export const DATA_ORIGINAL_TABINDEX = "data-original-tabindex";
export const TABINDEX_ATTRIBUTE = "tabindex";
export const TABINDEX_DISABLED_VALUE = "-1";
export const ARIA_HIDDEN_ATTRIBUTE = "aria-hidden";
export const ARIA_HIDDEN_TRUE_VALUE = "true";
export const ARIA_LABEL_ATTRIBUTE = "aria-label";

export const TRANSLATION_KEY_PREVIOUS = "plp_web_a11y_previous";
export const TRANSLATION_KEY_NEXT = "plp_web_a11y_next";
export const TRANSLATION_KEY_CATEGORY_CAROUSEL =
  "plp_web_a11y_category_carousel";
export const TRANSLATION_KEY_FACETED_NAV_CAROUSEL =
  "plp_web_a11y_faceted_nav_carousel";
export const TRANSLATION_KEY_RELATED_CATEGORIES_CAROUSEL =
  "plp_web_a11y_related_categories_carousel";
export const TRANSLATION_KEY_CAROUSEL_SR_TEXT = "plp_web_a11y_carousel_sr_text";
